import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

history.listen((location)=>{
  });

export default history;